import React from "react";
import { HashLink } from "react-router-hash-link";

import { Dialog, Classes, Tag } from "@blueprintjs/core";

import { Equipment } from "./Equipment";
import Exceptions from "./Exceptions";
import { Trans } from "react-i18next";
import Screenshot from "./Screenshot";
import { Camera } from "./Camera";
import { getSetting } from "../Settings/InstallationSettings";

export default class EquipmentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  render() {
    if (this.props.equipment !== undefined)
      return (
        <span
          style={{ width: "100%" }}
          onClick={() => {
            if (!this.props.extended) this.setState({ isOpen: true });
          }}
        >
          {this.props.children}
          {this.props.extended || (
            <Tag interactive={true} fill={true} rightIcon="info-sign">
              <Trans>show details</Trans>
            </Tag>
          )}

          {this.state.isOpen && (
            <Dialog
              hasBackdrop={false}
              isOpen={true}
              canEscapeKeyClose={true}
              canOutsideClickClose={true}
              autoFocus={true}
              className={Classes.OVERLAY_SCROLL_CONTAINER}
              onClose={() => {
                this.setState({ isOpen: !this.state.isOpen });
              }}
              style={{ transition: "none", width: "auto" }}
            >
              <div className={Classes.DIALOG_BODY}>
                <div>
                  <Equipment
                    eq={this.props.equipment}
                    extended={true}
                    ALPR_sensor={this.props.ALPR_sensor}
                  />
                  {(this.props.equipment.general.type === "S" ||
                    this.props.equipment.general.type === "C") && (
                    <Exceptions eq={this.props.equipment} />
                  )}
                </div>

                {getSetting(
                  "automatically display screenshot in equipment view",
                  false
                ) && (
                  <div
                    style={{
                      width: "25%",
                      position: "absolute",
                      right: "0%",
                      top: "0%",
                    }}
                  >
                    <Screenshot
                      eq={this.props.equipment.general.id}
                      srv={this.props.equipment.general.server}
                      minimal={true}
                    />
                  </div>
                )}

                {getSetting(
                  "automatically display video in equipment view",
                  false
                ) && (
                  <div
                    style={{
                      width: "25%",
                      position: "absolute",
                      right: "0%",
                      bottom: "0%",
                    }}
                  >
                    <Camera
                      eq={this.props.equipment.general.id}
                      srv={this.props.equipment.general.server}
                      minimal={true}
                    />
                  </div>
                )}
              </div>
            </Dialog>
          )}
        </span>
      );
    else
      return (
        <HashLink smooth to={`#device${this.props.equipmentId}`}>
          {this.props.children}
          <Tag>{this.props.text}</Tag>
        </HashLink>
      );
  }
}
